import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";
import interfaceEs from "./interfaceEs.json";
import esMissing from "./esMissing.json";

// Fusiona claves anidadas sin perder las traducciones ya existentes.
const deepMerge = (base, extra) => {
	const out = { ...base };
	for (const [key, value] of Object.entries(extra)) {
		if (value && typeof value === "object" && !Array.isArray(value)) {
			out[key] = deepMerge(out[key] ?? {}, value);
		} else {
			out[key] = value;
		}
	}
	return out;
};

const esTranslations = deepMerge(messages.es?.translations ?? {}, esMissing);

// Obtém o idioma salvo ou usa 'pt' como fallback inicial
const savedLang = localStorage.getItem('i18nextLng');

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	load: "languageOnly",
	fallbackLng: (language) => {
		const base = (language || savedLang || "pt").split(/[-_]/)[0].toLowerCase();
		return messages[base] ? [base] : ["pt"];
	},
	ns: ["translations"],
	resources: {
		...messages,
		es: { ...messages.es, translations: esTranslations, interface: interfaceEs },
	},
	detection: {
		order: ['localStorage', 'navigator'], // Prioriza localStorage
		caches: ['localStorage'],
		lookupLocalStorage: 'i18nextLng',
	},
});

export { i18n };
